// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"f36720af","545":"ea2c4593"}[chunkId] + ".chunk.js";
};